export const createMappings = (encoderMap, breakerMap) => {
    const newEncoderMap = new Map();
    const newBreakerMap = new Map();

    encoderMap.forEach((value) => {
        newEncoderMap.set(value.id, value);
    });

    breakerMap.forEach((value) => {
        newBreakerMap.set(value.id, value);
    });
};

export const createEncoderBreakerNodeMappings = (nodes: any) => {
    const encoderIdentifierMap = new Map();
    const breakerIdentifierMap = new Map();

    Object.entries(nodes).forEach(([, node]: any) => {
        if (node.type === "Main/CellBreakerNode") {
            return breakerIdentifierMap.set(node.id, node);
        }
        if (node.type === "Main/CellularEncoderNode") {
            return encoderIdentifierMap.set(node.id, node);
        }
    });

    return {
        encoderIdentifierMap,
        breakerIdentifierMap
    };
};

export const GetUpdatedFlows = (editor) => {
    const nodes = editor?.graph?._nodes_by_id;
    const { encoderIdentifierMap, breakerIdentifierMap } = createEncoderBreakerNodeMappings(nodes);
    const updatedFlows: any = [];
    const _graph = editor?.graph;
    const checkedLinks = new Map();

    Object.entries(_graph.links).forEach(([, link]: any) => {
        // check if the link has been inspected
        if (checkedLinks.has(link.id)) {
            return;
        }

        // Check both the source and target is source, are part of the encoderIdentifierMap, breakerIdentifierMap
        if (encoderIdentifierMap.has(link.target_id) && breakerIdentifierMap.has(link.origin_id)) {
            const identifier = encoderIdentifierMap.get(link.target_id);
            const previousCell = breakerIdentifierMap.get(link.origin_id);
            identifier.group_id !== previousCell.group_id &&
                updatedFlows.push({
                    identifier: identifier["group_id"],
                    previous: previousCell["group_id"]
                });
            identifier.group_id === previousCell.group_id &&
                identifier.group_id === 1 &&
                identifier.type === "Main/CellularEncoderNode" &&
                updatedFlows.push({
                    identifier: identifier["group_id"],
                    previous: null
                });
            checkedLinks.set(link.id, link);
            return;
        }
    });

    return {
        updatedFlows
    };
};
